import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { getBannerAction } from "../../../actions/banner";
import { RoutesPaths } from "../../../Router/constant";
import { BANNER_CTA_OPTIONS, BANNER_PROILE_TYPE_OPTIONS, BANNER_TYPE, MESSAGE_TYPE } from "../../../constants";
import { selectedCompanyStepAction, selectPendingCompany } from "../../../actions/company";
import { sendMessageToAdminChat } from "../../../actions/chatv2";
import { startLoaderAction, stopLoaderAction } from "../../../actions/updateReducerValue";
import { isMobile } from "react-device-detect";
// import "./slider-card.css";

const ChevronLeft = (props) => (
    <svg viewBox="0 0 24 24" width={20} height={20} {...props}>
        <path d="M15.5 19 8.5 12l7-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
const ChevronRight = (props) => (
    <svg viewBox="0 0 24 24" width={20} height={20} {...props}>
        <path d="m8.5 19 7-7-7-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export default function AdvisorSlider({
    autoPlay = true,
    interval = 6000,
}) {


    const dispatch = useDispatch();
    const { bannerList } = useSelector((state) => state.banner);
    const navigate = useNavigate();
    const { selectedCompany } = useSelector((state) => state.company);

    useEffect(() => {
        dispatch(getBannerAction());
    }, [dispatch]);

    const redirect = async (info) => {
        switch (info.bannerType) {
            case BANNER_TYPE.PLAN:
                navigate(RoutesPaths.PRODUCT_PAGE.replace(":slug", info?.cta?.slug));
                break;
            case BANNER_TYPE.EXTERNAL:
                window.open(info.cta, "_blank");
                break;
            case BANNER_TYPE.MODAL:
                if (info?.cta?.value === BANNER_CTA_OPTIONS.ADD_NEW_DASHBOARD) {
                    navigate(RoutesPaths.ADD_COMPANY);
                    dispatch(selectPendingCompany(null));
                    dispatch(selectedCompanyStepAction(1));
                } else if (info?.cta?.value === BANNER_CTA_OPTIONS.INVITES) {
                    navigate(RoutesPaths.INVITE);
                } else if (info?.cta?.value === BANNER_CTA_OPTIONS.CHAT) {
                    dispatch(startLoaderAction());
                    await sendMessageToAdminChat(`${info.message ? info.message : ""}`, selectedCompany, MESSAGE_TYPE.CONTACT_US_BUTTON, navigate, []);
                    dispatch(stopLoaderAction());
                }
                break;
            default:
                break;
        }
    };

    const getImage = (info) => {
        return isMobile ? info?.mobileImage?.filename : info?.webImage?.filename;
    };

    const userType = selectedCompany?.isDefault ? BANNER_PROILE_TYPE_OPTIONS.USER : BANNER_PROILE_TYPE_OPTIONS.COMPANY;
    const filteredBanners = bannerList?.filter((banner) => banner.profileType === userType);


    const [i, setI] = useState(0);
    const timer = useRef(null);

    const next = () => setI((p) => (p + 1) % filteredBanners.length);
    const prev = () => setI((p) => (p - 1 + filteredBanners.length) % filteredBanners.length);
    const go = (idx) => setI(idx);

    useEffect(() => {
        if (!autoPlay || filteredBanners.length <= 1) return;
        timer.current && clearInterval(timer.current);
        timer.current = setInterval(next, interval);
        return () => clearInterval(timer.current);
    }, [i, autoPlay, interval, filteredBanners.length]);

    const s = filteredBanners[i] || {};



    return (
        <div className="promo-wrap" style={{
            backgroundImage: `url(/assets/img/extraImage/bannerBackground.jpg)`,
            backgroundSize: "cover",
            backgroundPosition: "center",
        }}
        >
            <div className="dotsClass">
                {/* dots (top-left) */}
                <div className="dots">
                    {filteredBanners?.map((_, idx) => (
                        <span
                            key={idx}
                            className={`dot ${idx === i ? "active" : ""}`}
                            onClick={() => go(idx)}
                        />
                    ))}
                </div>

                {/* arrows (top-right) */}
                <div className="arrows">
                    <button className="arrow" aria-label="Previous" onClick={prev}>
                        <ChevronLeft />
                    </button>
                    <button className="arrow" aria-label="Next" onClick={next}>
                        <ChevronRight />
                    </button>
                </div>

            </div>

            {/* content */}
            <div className="promo-inner row">
                <div className="promo-left col-sm-12 col-md-8">
                    <h2 className="promo-title">{s.title}</h2>
                    <p className="promo-text">{s.description}</p>

                    {s.cta_text && (
                        <button onClick={() => redirect(s)} type="button" className='customFilterButton mobileViewImportButton'>
                            {s.cta_text}
                        </button>
                    )}
                </div>

                <div className="promo-right col-sm-12 col-md-4">
                    <div className="promo-illustration" aria-hidden="true">
                        <img className="promo-illustration" src='assets/img/banner_side_image.svg' alt={s.imageAlt || ""} />
                        {/* optional placeholder if no image is provided */}
                    </div>
                </div>
            </div>
        </div>
    );
}

/* Demo usage */
export function DemoSlider() {
    return <AdvisorSlider />;
}
